import cn from 'classnames';

import styles from './Table.module.scss';

export const OverbookedLabel = ({className, ...props}: JSX.IntrinsicElements['div']) => (
  <div className={cn(styles.overbooked, className)} {...props}>
    !
  </div>
);
